import MuiDrawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

// 288px is the narrowest width that still fits the longest branch name in the
// header select. The rail carries 40px icon buttons, centered on it by their own
// auto margins, so its width is breathing room either side of them and nothing
// else - 68px leaves 14px, where 76px read as a wide empty strip.
export const OPEN_DRAWER_WIDTH = '288px';
export const CLOSED_DRAWER_WIDTH = '68px';

// The gutter the rail sits in. Narrower while collapsed, where the whole point is
// to give the width back to the page.
export const OPEN_DRAWER_GUTTER = '16px';
export const CLOSED_DRAWER_GUTTER = '8px';

// Half a second reads as lag on a bar this size - long enough to watch rather than
// to follow the click.
export const TRANSITION_DURATION = 0.25;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  '& .MuiDrawer-paper': {
    position: 'relative',
    width: open ? OPEN_DRAWER_WIDTH : CLOSED_DRAWER_WIDTH,
    // Width alone. `all` animated every property that differs between the two
    // states, so the browser recomputed the lot each frame for one that moves.
    transition: `width ${TRANSITION_DURATION}s ease-in-out`,
    // Says up front that the width is what moves, so the rail is promoted once
    // rather than re-evaluated on every frame of it.
    willChange: 'width',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    visibility: 'visible !important',
    transform: 'unset !important',
  },
  ...(!open && {
    '& .sidebar-scroll': {
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  }),
}));

export default Drawer;
